import { CsLink, CsNewsCard, CsTabs, MsHeadline } from '@sunrise/components'
import { MsDocument, MsHorn } from '@sunrise/icons'
import { extractLink, useGlobalStore } from '@sunrise/shared'
import { Cms, RequestContext } from '@sunrise/types'
import { PropType, Ref, computed, defineComponent, ref, watch } from 'vue'
import { NewsType, PoliceRssNewsResponse } from '../../../../services/newsService/newsService.interface'
import { ViewNewsItem } from '../M_NewsTabs.interface'
import { getNewsTracking, mlmTrackViews } from '../M_NewsTabsTracking'

export default defineComponent({
    name: 'HydratedNewsTabs',
    components: { CsNewsCard, CsTabs, MsHeadline, MsHorn, MsDocument, CsLink },
    props: {
        policeLink: {
            type: Object as PropType<ReturnType<typeof extractLink>>,
            required: true,
        },
        policeHeadline: {
            type: String,
            required: true,
        },
        newsLink: {
            type: Object as PropType<ReturnType<typeof extractLink>>,
            required: true,
        },
        newsHeadline: {
            type: String,
            required: true,
        },
        reverseOrder: Boolean,
        news: Array as PropType<ViewNewsItem[]>,
        serviceData: Object as PropType<PoliceRssNewsResponse>,
    },

    setup(props) {
        const options = computed(() => buildOptions(props.policeHeadline, props.newsHeadline, props.reverseOrder))
        const modelValue = ref(options.value[0])
        const currentNewsType = computed(() =>
            modelValue.value === props.policeHeadline ? NewsType.POLICE : NewsType.RSS,
        )
        const propsByNewsType = computed(() => determineProps(currentNewsType, props.policeLink, props.newsLink))

        function showItem(item: ViewNewsItem) {
            return currentNewsType.value === item.type
        }

        function createNewsTracking(newsItem: ViewNewsItem) {
            const requestContext = useGlobalStore().requestContext as RequestContext
            return getNewsTracking(newsItem, requestContext.url)
        }

        const watchStop = watch(modelValue, (newValue) => {
            if (newValue === props.newsHeadline) {
                if (props.serviceData) {
                    mlmTrackViews(props.serviceData.rssNews, document.URL)
                }
                watchStop()
            }
        })

        return {
            modelValue,
            options,
            showItem,
            createNewsTracking,
            propsByNewsType,
        }
    },
})

function determineProps(newsType: Ref<NewsType>, policeLink: Cms.ContentTag | null, newsLink: Cms.ContentTag | null) {
    const isPolice = newsType.value === NewsType.POLICE

    return {
        iconComponentName: isPolice ? MsHorn : MsDocument,
        link: isPolice ? policeLink : newsLink,
    }
}

function buildOptions(policeHeadline: string, newsHeadline: string, isReversedOrder: boolean) {
    const options = [policeHeadline, newsHeadline]

    return isReversedOrder ? options.reverse() : options
}
